<template>
  <van-popup id="choosesite" v-model="popupshow" position="right" :overlay="true" class="popupleft">
    <div>
      <!--头部-->
      <!-- <van-nav-bar title="我的地址" fixed >
      <van-icon slot="left" class="iconfont icon-zuojiantou" style="font-size: .25rem" @click="chooseSiteShow"></van-icon>
    </van-nav-bar> -->
      <GlobTopNav title="我的地址"></GlobTopNav>
      <!--地址-->
      <div class="van-content">
        <!--<van-address-list class="addressList" v-model="chosenAddressId" @edit="amendSite" :list="siteList" v-if="siteList[0].id != ''">-->
        <!--</van-address-list>-->
        <div v-if="siteList[0].id != ''" class="addressList van-address-list">
          <div v-for="(items, index) in siteList" :key="index" class="van-radio-group">
            <div class="van-cell-group van-hairline--top-bottom">
              <div style="position: relative" class="van-cell van-cell--clickable van-address-item">
                <div class="van-cell__value van-cell__value--alone">
                  <div @click="chooseSite(items.id)" class="van-radio" style="position: relative">
                    <i
                      v-if="items.id != id"
                      style="font-size: 0.4rem"
                      class="iconfont icon-weixuanzhong"
                      radio
                    ></i>
                    <i
                      v-if="items.id == id"
                      style="font-size: 0.4rem"
                      class="iconfont icon-xuanzhong theme-col radio"
                    ></i>
                    <span class="van-radio__label">
                      <div class="van-address-item__name" style="overflow: hidden; width: 90%">
                        {{ items.name }}<span class="float-right">{{ items.tel }}</span>
                        <span v-if="items.moren == 1" class="moren">默认</span>
                      </div>
                      <div class="van-address-item__address">
                        <span>{{ items.address }}</span>
                      </div>
                    </span>
                  </div>
                </div>
                <i
                  style="
                    position: absolute;
                    top: 50%;
                    margin-top: -0.2rem;
                    right: 0.3rem;
                    font-size: 0.3rem;
                  "
                  @click="amendSite(items, index)"
                  class="iconfont icon-bianji"
                ></i>
              </div>
            </div>
          </div>
        </div>
        <van-cell-group v-else>
          <van-cell>新增收货地址</van-cell>
        </van-cell-group>
      </div>
      <router-link to="/user/mysite/addsite" class="addSiteBtn"
        ><van-button size="large" class="theme-bd theme-bg">新增收货地址</van-button></router-link
      >
    </div>
  </van-popup>
</template>

<script>
import Bus from '../../../static/js/bus.js'
export default {
  name: 'choosesite',
  data() {
    return {
      popupshow: false,
      chosenAddressId: '',
      siteList: [
        {
          id: '',
          name: '',
          tel: '',
          address: ''
        }
      ],
      id: ''
    }
  },
  watch: {
    chosenAddressId: function () {
      if (this.popupshow == true) {
        var site
        var _this = this
        $.each(this.siteList, function (index, item) {
          if (item.id == _this.chosenAddressId) {
            site = item
          }
        })
        this.chooseSiteShow()
        this.$emit('listenSitedata', site, this.chosenAddressId)
      }
    }
  },
  methods: {
    amendSite: function (item, index) {
      this.$router.push({ path: '/user/mysite/amendsite', query: { id: item.id } })
    },
    chooseSiteShow: function () {
      this.popupshow = !this.popupshow
    },
    chooseSite: function (id) {
      this.popupshow = !this.popupshow
      var site
      var _this = this
      $.each(this.siteList, function (index, item) {
        if (item.id == id) {
          site = item
        }
      })
      //        this.chooseSiteShow()
      this.$emit('listenSitedata', site, id)
    },
    getDatas: function () {
      var isUser = localStorage.getItem('BLHuser')
      var mallid = localStorage.getItem('mallid')
      var _this = this
      this.$api.get('user/address/list', { id_example: mallid, token_user: isUser }, res => {
        if (res.data.data != null) {
          this.siteList = []
          $.each(res.data.data, function (index, item) {
            if (item.default == 1) {
              _this.chosenAddressId = item.id
            }
            var siteObj = {
              id: item.id,
              name: item.name,
              tel: item.phone,
              address:
                item.province_str + item.city_str + item.county_str + item.town_str + item.address,
              moren: item.default
            }
            _this.siteList.push(siteObj)
          })
        }
      })
    }
  },
  mounted() {
    var vm = this
    Bus.$on('steat', function (data) {
      vm.id = data
    })
    this.getDatas()
  }
}
</script>

<style lang="less" scoped>
#choosesite {
  background: #f5f5f5;

  .van-content {
    height: calc(100vh - 2.5rem);
    overflow-y: auto;
    .van-radio__label {
      width: 100%;

      .van-address-item__name {
        font-size: 0.3rem;
        font-weight: bold;
        color: #262626;
        line-height: 0.42rem;
      }

      .van-address-item__address {
        font-size: .28rem;
        font-weight: 400;
        color: rgba(38, 38, 38, 0.8);
        line-height: .48rem;
      }
    }

    .van-radio {
      display: flex;
      align-items: center;
    }
  }

  .moren {
    width: 0.6rem;
    height: 0.28rem;
    background: #fe5c42;
    border-radius: 0.06rem;
    font-size: 0.2rem;
    font-weight: 500;
    color: #ffffff;
    line-height: 0.28rem;
    text-align: center;
    margin-left: 0.1rem;
  }
  .addSiteBtn {
    border-right: 0;
    width: 100%;
    padding: 0.2rem 0.2rem;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    background: #fff;
    button {
      border-radius: 0.8rem;
      border: none;
      width: 100%;
      float: left;
    }
    .radio {
      position: absolute;
      top: 50%;
      left: 0.15rem;
    }
  }
  .van-address-item__address {
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/affirmorder/choosesite.vue